import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {GameThemeFilterDefinition} from "../filters-definitions/theme/game-theme.filter-definition";
import {CategoryDefinitionId} from "./filter-category-definition.interface";

export class GameThemeFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'themes';
    }

    get title(): string{
        return this.services.translation.translate('THEME');
    }

    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        const allThemes = this.services.sdk.getGamesThemes();
        const filters = Object.keys(allThemes).map(id => {
            const themeId = Number(id);
            const themeName = allThemes[themeId];
            return new GameThemeFilterDefinition(this.services, themeId, themeName);
        });
        return filters;
    }
}